import { render, staticRenderFns } from "./RepairFaqs.vue?vue&type=template&id=2a1877ec&scoped=true&"
import script from "./RepairFaqs.vue?vue&type=script&lang=js&"
export * from "./RepairFaqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1877ec",
  null
  
)

export default component.exports